// src/rtkQuery/config/videoApi.config.ts 

export const VIDEO_API_ROUTES = {
  getAll: '/videos/videos',
  confirmWatch: '/videos/confirmWatch',
  watchedVideos: '/videos/watchedVideos',
};
